import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=1fc03722&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"
import style0 from "./login-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzTextField: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/text-field/index.js').default,RzButton: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/button/index.js').default})
